module.exports = __webpack_public_path__ + "img/技术优势.03855a38.png";